<template>
<div class="home">

  <!-- Added key in order to re-render component when some part of route is changed -->
  <router-view :key="$route.fullPath" v-if="isGranted(permissions.MAINTENANCE_VIEW)"/>

</div>
</template>

<script>

import piincHttp from '@/util/configureAxios.js';
import roleCheck from "@/util/ACL/roleCheck"

export default {
  name: 'Maintenance',
  data: function() {
    return {
    }
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function (newValue, oldValue) {
      if (newValue && oldValue && newValue.slug !== oldValue.slug) {
        if (roleCheck('Client admin') || roleCheck('Validator')) {
          // Do nothing
        } else {
          this.$router.push('/')
        }
      }
    }
  },
  components: {
  },
  computed: {
    getClient() {
      return this.$store.state.client
    }
  },
  created () {

    // // When this component is created, set active navigation to "maintenance"
    this.$store.commit('setNavType', 'maintenance');

  },
  beforeRouteLeave (to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    this.$store.commit('setNavType', 'main');
    // Used to set navigation type back to default
    // When navigation is properly set, allow leaving the route
    next();
  }
}
</script>

<style scoped lang="scss">
  h1 {
    font-size: 75px;
    margin-top: 100px
  }
</style>
